enum SocialShareType {
  FB, TW, LD, MAIL, WECHAT, WEIBO
}

export default SocialShareType;
